"use client";

import { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { useComponentLifecycle } from "@stadium/hooks/lib/use-component-lifecycle";

import Confirmation from "@components/store/confirmation";
import { useStoreContext } from "@components/store/provider";

import { getDefaultKitStoreProps } from "@helpers/store";
import { useParams } from "next/navigation";
import { CheckAuthHocV2 } from "@stadium/services/auth0";
import { ORDER_SERVICE_API_BASE_URL } from "@constants/env-variables";
import { LOGIN_CALLBACK_ROUTE } from "@constants/routes";
import loaders from "@stadium/ui/src/components/loaders/loaders";
import { getStore } from "@selectors/store";

const DEFAULT_OBJ = {};

const OrderConfirmation = () => {
  const { orderNumber } = useParams();
  const { setPageState, resetPageState } = useStoreContext();

  const store = useSelector(getStore);

  useComponentLifecycle({ onUnmount: resetPageState });

  const { isKitShop } = store || DEFAULT_OBJ;
  const storeProviderProps = useMemo(() => getDefaultKitStoreProps(isKitShop), [isKitShop]);

  useEffect(() => {
    setPageState((state) => ({
      ...state,
      ...storeProviderProps,
      withMenu: false,
      source: "confirmation",
      withCart: false,
      showTalkToSalesCta: false,
    }));
  }, [storeProviderProps]);

  return <Confirmation orderNumber={orderNumber} />;
};

const AuthenticatedConfirmation = CheckAuthHocV2(OrderConfirmation, {
  apiHost: ORDER_SERVICE_API_BASE_URL,
  Loader: loaders.PageLoader,
  loginCallbackRoute: LOGIN_CALLBACK_ROUTE,
});

export default AuthenticatedConfirmation;
